import axios from "axios";
import { BASE_URL } from "../Config";
import { encrypt } from "./crypto";
import { encryptedData } from ".";

const sendRequest = async (endpoint, data, method = "POST", rtoken) => {
  var newendpointParts = endpoint.split("/");
  // console.log(newendpointParts);
  if (newendpointParts[1] === "epl") {
    var newEndpoint = "/" + newendpointParts[1] + "/v1/" + newendpointParts[2];
  } else {
    var newEndpoint = "/" + newendpointParts[1] + "/1.0/" + newendpointParts[2];
  }
  let path = BASE_URL + newEndpoint;
  // console.log("path: ", path);
  var wso2ApiKey =
    "eyJ4NXQiOiJOMkpqTWpOaU0yRXhZalJrTnpaalptWTFZVEF4Tm1GbE5qZzRPV1UxWVdRMll6YzFObVk1TlE9PSIsImtpZCI6ImdhdGV3YXlfY2VydGlmaWNhdGVfYWxpYXMiLCJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJhZG1pbkBjYXJib24uc3VwZXIiLCJhcHBsaWNhdGlvbiI6eyJvd25lciI6ImFkbWluIiwidGllclF1b3RhVHlwZSI6bnVsbCwidGllciI6IlVubGltaXRlZCIsIm5hbWUiOiJPbmVhcHAiLCJpZCI6MTgsInV1aWQiOiIyYTQyYmU0ZS1iNjUxLTRjZjMtOTdlMy1kZjg3MjgyZTEyZGIifSwiaXNzIjoiaHR0cHM6XC9cLzE3Mi4xNjguMTUuMTM5Ojk0NDNcL29hdXRoMlwvdG9rZW4iLCJ0aWVySW5mbyI6eyJVbmxpbWl0ZWQiOnsidGllclF1b3RhVHlwZSI6InJlcXVlc3RDb3VudCIsImdyYXBoUUxNYXhDb21wbGV4aXR5IjowLCJncmFwaFFMTWF4RGVwdGgiOjAsInN0b3BPblF1b3RhUmVhY2giOnRydWUsInNwaWtlQXJyZXN0TGltaXQiOjAsInNwaWtlQXJyZXN0VW5pdCI6bnVsbH19LCJrZXl0eXBlIjoiUFJPRFVDVElPTiIsInBlcm1pdHRlZFJlZmVyZXIiOiIiLCJzdWJzY3JpYmVkQVBJcyI6W3sic3Vic2NyaWJlclRlbmFudERvbWFpbiI6ImNhcmJvbi5zdXBlciIsIm5hbWUiOiJPbmVhcHBfVXBzZWxsIiwiY29udGV4dCI6Ilwvb25lYXBwXC91cHNlbGxcLzEuMCIsInB1Ymxpc2hlciI6ImFkbWluIiwidmVyc2lvbiI6IjEuMCIsInN1YnNjcmlwdGlvblRpZXIiOiJVbmxpbWl0ZWQifSx7InN1YnNjcmliZXJUZW5hbnREb21haW4iOiJjYXJib24uc3VwZXIiLCJuYW1lIjoiT25lYXBwX0VQTCIsImNvbnRleHQiOiJcL29uZWFwcFwvZXBsXC92MSIsInB1Ymxpc2hlciI6ImFkbWluIiwidmVyc2lvbiI6InYxIiwic3Vic2NyaXB0aW9uVGllciI6IlVubGltaXRlZCJ9XSwidG9rZW5fdHlwZSI6ImFwaUtleSIsInBlcm1pdHRlZElQIjoiIiwiaWF0IjoxNjkxMDUyNzIwLCJqdGkiOiI0MmI2ZjkzNC1hMDY4LTRkNWYtYTYzOC01YmZjZWUyNWM2OWEifQ==.W02uftodu2z2Mq-e4olgu4HSs0NRSDT4mxe49GEivEnaNMFwDT7t19GWd-d3Bd9rbgpNpVwQ70y7M62QDNwn1CGzbsjqXuXndngD9PR4mXtKMY-ejF1yE_tWzfyApPqMVIwhmmFxDB3mMx76aMICSdf74hpSieRjieSKObjdWHdbpdufRTEHhbTZ5GghTWtKJGV8_M45tFKW0RjKpKkVpTuVZRNVOsgLr4Ki5nOBlihblIzB7Vl1ByfxmCklWdIN7EJzLSHPhdeGvzNVdFxcUub1Eb54ItC_BPHW_4CVAJ_a-wJkQjDyJOrnR45p5QQJeZ7I0E6IE1EqMxP3CyuzVg==";
  var headerToken = sessionStorage.getItem("headerToken");
  const config = {
    headers: { Token: `${headerToken}`, apikey: `${wso2ApiKey}`, "Recaptcha-Token": rtoken},
  };
  // console.log(config);
  if (method === "POST") {
    let formData = new FormData();
    if (data instanceof FormData) {
      formData = data;
    } else {
      formData.append("data", encryptedData(data));
    }
    return axios.post(path, formData, config);
  } else {
    return axios.get(path, config);
  }
};

export default sendRequest;
